/* AutoShineX — "Buy now" wiring (Shopflo-friendly, ZERO Shop Pay JS).
 * The button is rendered server-side in blocks/accelerated-checkout.liquid (paints instantly
 * next to Add to cart). This script attaches the click behaviour: add the BUTTON'S OWN
 * variant+qty to the cart, then open Shopflo checkout.
 *
 * FIX (2026-10-29): previously it used a single page-level mainForm() which, on collection /
 * home (no .product-information), returned forms[0] = the FIRST product card on the page — so
 * every card's "Buy now" bought the first product (e.g. Scratch Remover / the first combo).
 * Now each button resolves ITS OWN enclosing product form (the button sits inside its card's
 * form), with a product-container and PDP fallback. Event delegation wires every button,
 * including cards added after load.
 */
(function () {
  'use strict';

  // PDP fallback only: the product-information add-to-cart form.
  function pdpForm() {
    var forms = Array.prototype.slice.call(
      document.querySelectorAll('form.shopify-product-form[data-type="add-to-cart-form"]')
    );
    if (!forms.length) return null;
    var pref = forms.filter(function (f) {
      return f.closest('.product-information, [class*="product-information"]');
    });
    return pref[0] || forms[0];
  }

  // The add-to-cart form that belongs to THIS button — never the page's first form.
  function formForButton(btn) {
    // 1) the form that CONTAINS the button (true on both PDP and each card).
    var f = btn.closest('form.shopify-product-form[data-type="add-to-cart-form"]');
    if (f) return f;
    // 2) the nearest product container, then the form inside it.
    var scope = btn.closest(
      '.product-card, product-card, [class*="product-card"], .product-information, [class*="product-information"]'
    );
    if (scope) {
      var sf = scope.querySelector('form.shopify-product-form[data-type="add-to-cart-form"]');
      if (sf) return sf;
    }
    // 3) PDP fallback.
    return pdpForm();
  }

  function openShopfloCheckout() {
    // Open the Shopflo checkout for the CURRENT cart (we already added the correct variant via
    // /cart/add.js). Do NOT use window.handleFloBuyNowBtn(): on non-PDP pages (home, collection,
    // related) that Shopflo "Buy now" handler re-adds the page's FIRST product form (e.g. Scratch
    // Remover), overwriting the cart — the exact bug this file fixes. handleFloCheckoutBtn() opens
    // the overlay for whatever is already in the cart, with no re-add. (verified 2026-10-29.)
    if (typeof window.handleFloCheckoutBtn === 'function') {
      try { window.handleFloCheckoutBtn(); return true; } catch (e) {}
    }
    if (window.Shopflo && typeof window.Shopflo.openCheckout === 'function') {
      try { window.Shopflo.openCheckout(); return true; } catch (e) {}
    }
    return false;
  }

  function handle(btn) {
    if (btn.disabled || btn.__asxBusy) return;

    var form = formForButton(btn);
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = form && form.querySelector('[name="quantity"]');
    var id = idInput && idInput.value;
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    if (!id) return;

    btn.__asxBusy = true;
    btn.disabled = true;
    var label = btn.querySelector('span');
    var orig = label ? label.textContent : 'Buy now';
    if (label) label.textContent = 'Opening…';

    function reset() {
      btn.__asxBusy = false;
      btn.disabled = false;
      if (label) label.textContent = orig;
    }

    var hooks = {
      onOpen: function () { setTimeout(reset, 400); },
      onRedirect: function () { if (label) label.textContent = 'Redirecting…'; },
      onError: function (err) {
        btn.__asxBusy = false;
        btn.disabled = false;
        if (label) label.textContent = (err && (err.description || err.message)) ? 'Unavailable' : 'Try again';
        setTimeout(function () { if (label) label.textContent = orig; }, 2200);
      }
    };

    // The cart-preserving express Buy now (snapshot → single item → checkout → restore on
    // close) lives in asx-card-cart.js, which loads on every page. Use it.
    if (typeof window.__asxBuyNow === 'function') { window.__asxBuyNow(id, qty, hooks); return; }

    // Fallback (shared helper not loaded): add this variant and open checkout. Deliberately
    // does NOT clear the cart — better to show extra items than to wipe the shopper's cart.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty }),
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) return Promise.reject(data); // 422 (sold out) must fail — never checkout empty
          return data;
        });
      })
      .then(function () {
        if (openShopfloCheckout()) { setTimeout(reset, 400); return; }
        if (label) label.textContent = 'Redirecting…';
        window.location.href = '/checkout';
      })
      .catch(hooks.onError);
  }

  // Event delegation — every .asx-pdp-buynow on PDP, collection and home, incl. lazy-loaded cards.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.asx-pdp-buynow');
    if (!btn) return;
    e.preventDefault();
    handle(btn);
  });
})();
